/**
 * EventView view component.
 * @module components/theme/View/EventView
 */
import PropTypes from 'prop-types';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { UniversalLink } from '@plone/volto/components';
import config from '@plone/volto/registry';
import { Icon, FormattedDate } from '@plone/volto/components';
import rightArrow from '@plone/volto/icons/backspace.svg';

const EventView = ({ content }) => {
  console.log(content);

  const Container =
    config.getComponent({ name: 'Container' }).component || SemanticContainer;
  return (
    <div id="page-document" className="view-wrapper newsitem-view">
      <UniversalLink
        style={{ display: 'flex', alignItems: 'center', marginBottom: '40px' }}
        className="content"
        href="/eventos"
      >
        <Icon size="25px" name={rightArrow} />
        Volver a Eventos
        <div style={{ marginLeft: '10px', background: 'red' }}></div>
      </UniversalLink>
      <div className="dates">
        {content?.start ? (
          <span className="day">
            <FormattedDate date={content?.start} />{' '}
          </span>
        ) : (
          <span className="day">{content?.created}</span>
        )}{' '}
        {content?.head_title && (
          <span className="head-title"> {content?.head_title}</span>
        )}
      </div>
      <RenderBlocks content={content} />
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
EventView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    text: PropTypes.shape({
      data: PropTypes.string,
    }),
  }).isRequired,
};

export default EventView;
